import { FunctionsHttpError } from '@supabase/supabase-js'
import { supabase } from '../lib/supabase'
import type { Modelo } from '../utils/simulador'

export type DadosSimulador = { marca: string; conversao: string | null; inicio: string; fim: string; modelos: Modelo[]; demo: boolean }

/** Os modelos de cada campanha da marca, medidos pelo motor nos últimos 90 dias. */
export async function carregarSimulador(marcaId: string): Promise<DadosSimulador> {
  const { data, error } = await supabase.functions.invoke('simulador-orcamento', { body: { marca_id: marcaId } })
  if (error) {
    const detalhe = error instanceof FunctionsHttpError ? await error.context.json().catch(() => null) : null
    throw new Error(detalhe?.erro ?? error.message)
  }
  return data as DadosSimulador
}
